import React, { Component, ReactNode } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { CustomParams, Meta, Query, LocalizedLabels, RatatoskRequest, RatatoskPage, RatatoskResponse, getLocalizedLabel, getmeta, featureValueTypes, valueIsIntNumber, descFiller, descSlot, getRefTargets, subspecUnique, valueByFormikPath, valueDefined } from '../../common'
import { AxiosInstance } from 'axios'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Button, Container, Input as PInput, Dropdown as PDropdown, DropdownItemProps, Grid, Header, Icon, Label, Message, Segment, Tab, SemanticWIDTHS, GridColumn, Modal, ModalHeader } from 'semantic-ui-react'
import { EditFormProps, addFeature, lastChangeLabel } from '../Edit'
import Input from './Input'
import {FormikComponentProps, getFieldError, setFieldValue} from './FormikHelpers'
import { FieldArray } from 'formik'
import TextArea from './TextArea'
import Dropdown from './Dropdown'
import Checkbox from './Checkbox'
import InputFeatureValue from './InputFeatureValue'
import InputFeatureType from './InputFeatureType'
import LemurOrderRestrHelp from '../CustomComponents/LemurOrderRestrHelp'

const customHelpComponents = {
    LemurOrderRestrHelp: LemurOrderRestrHelp
}


interface EditFeatureFormState {
  versionedFeatureTypeEdit: string|null,
  versionedFeatureTarget: string|null,
  versionedFeatureSubspec: string|null
  versionedFeatureValue: string,
  versionedFeatureFormik: any|null,
  versionedFeatureCurrentVersion: string|null,
  versionedFeatureMessage: ReactNode|null
}

class EditFeatureForm extends Component<EditFormProps, EditFeatureFormState> {

    state = {
        versionedFeatureTypeEdit: null,
        versionedFeatureSubspec: null,
        versionedFeatureTarget: null,
        versionedFeatureValue: '',
        versionedFeatureFormik: null as any|null,
        versionedFeatureCurrentVersion: null,
        versionedFeatureMessage: null
    }

    componentDidMount() {
    }

    closeVersionedFeature() {
        this.setState({
            versionedFeatureTypeEdit: null,
            versionedFeatureSubspec: null,
            versionedFeatureTarget: null,
            versionedFeatureValue: '',
            versionedFeatureFormik: null as any|null,
            versionedFeatureCurrentVersion: null,
            versionedFeatureMessage: null
        })
    }

    changeVersionedFeature(formik, target, basetype, current_version) {
        this.setState({
            versionedFeatureTypeEdit: basetype,
            versionedFeatureTarget: target,
            versionedFeatureValue: '',
            versionedFeatureFormik: formik,
            versionedFeatureCurrentVersion: current_version
        })
    }

    getVersionIndices() {
        const formik: any|null = this.state.versionedFeatureFormik
        const target = this.state.versionedFeatureTarget
        const basetype = this.state.versionedFeatureTypeEdit
        const current_version = this.state.versionedFeatureCurrentVersion
        if (formik===null || target===null || basetype===null || !formik.values.feats[basetype] || !formik.values.feats[basetype][target]) return {current_index: -1, current_version_index: -1}
        // index of the current value if exists()
        const current_index = formik.values.feats[basetype][target].findIndex(f => f.subspec === this.state.versionedFeatureSubspec)
        const subspec_version = this.state.versionedFeatureSubspec ? this.state.versionedFeatureSubspec+':_'+current_version : '_'+current_version
        // index of the value with the current version (if already exists)
        const current_version_index = formik.values.feats[basetype][target].findIndex(f => f.subspec === subspec_version)
        return {current_index, current_version_index}
    }

    changeVersionedValue() {
        const {current_index, current_version_index} = this.getVersionIndices()
        const formik: any|null = this.state.versionedFeatureFormik
        const target = this.state.versionedFeatureTarget
        const basetype = this.state.versionedFeatureTypeEdit
        const current_version = this.state.versionedFeatureCurrentVersion
        if (basetype===null || target===null || formik===null) return
        if (this.state.versionedFeatureValue === formik.values.feats[basetype][target][current_index].value) return
        const subspec_version = this.state.versionedFeatureSubspec ? this.state.versionedFeatureSubspec+':_'+current_version : '_'+current_version
        // any current value set?
        if (current_index !== -1) {
            // if there is no value archived as the last/current version yet, create one to archive the current value
            if (current_version_index === -1) {
                const index = addFeature(formik, this.props.meta, target, basetype)
                if (index !== undefined) {
                    setFieldValue(formik, "feats['"+basetype+"']['"+target+"']["+index+"].value", formik.values.feats[basetype][target][current_index].value, true)
                    setFieldValue(formik, "feats['"+basetype+"']['"+target+"']["+index+"].subspec", subspec_version, true)
                }
            }
            // update the current value
            setFieldValue(formik, "feats['"+basetype+"']['"+target+"']["+current_index+"].value", this.state.versionedFeatureValue, true)
            setFieldValue(formik, "feats['"+basetype+"']['"+target+"']["+current_index+"].subspec", this.state.versionedFeatureSubspec, true) 
        } else {
            // set new value
            const index = addFeature(formik, this.props.meta, target, basetype)
            if (index !== undefined) {
                setFieldValue(formik, "feats['"+basetype+"']['"+target+"']["+index+"].value", this.state.versionedFeatureValue, true)
                setFieldValue(formik, "feats['"+basetype+"']['"+target+"']["+index+"].subspec", this.state.versionedFeatureSubspec, true)
            }
        }
        this.closeVersionedFeature()
    }

    componentDidUpdate(prevProps: EditFormProps, prevState: EditFeatureFormState) {
        if (this.state.versionedFeatureTypeEdit && (!prevState.versionedFeatureTypeEdit || this.state.versionedFeatureSubspec !== prevState.versionedFeatureSubspec)) {
            const {current_index, current_version_index} = this.getVersionIndices()
            const formik: any|null = this.state.versionedFeatureFormik
            const target = this.state.versionedFeatureTarget
            const basetype = this.state.versionedFeatureTypeEdit
            const current_version = this.state.versionedFeatureCurrentVersion
            if (basetype===null || target===null || formik===null) return
            let newstate = {'versionedFeatureMessage': null as ReactNode|null}
            // there is some value set for the versioned feature
            if (current_index !== -1) {
                newstate['versionedFeatureValue'] = this.state.versionedFeatureValue || formik.values.feats[basetype][target][current_index].value
                // no value is archived for the last/current version yet
                if (current_version_index === -1) {
                    newstate['versionedFeatureMessage'] = (
                        <Message info icon>
                            <Icon name="info circle"/>
                            <Message.Content>
                                <p>{this.props.t("Current value '{{value}}' will be replaced and archived as version {{version}}.", { value: formik.values.feats[basetype][target||''][current_index].value, version: current_version })}</p>
                            </Message.Content>
                        </Message>
                    )
                }
            }
            this.setState(newstate)
        }
    }

    render() {
        const { params, formik, meta, http, t, i18n, userMap, history, location } = this.props
        const { versionedFeatureTypeEdit } = this.state

        if (!meta['cats']) return null

        const parentIsDeleted = (sid, fid) => {
            if (!sid) return false
            const slot = formik.values.slots.filter(s => s._id === sid)[0]
            if (!slot) return true
            if (!fid || slot.delete) return slot.delete
            const filler = slot.fillers.filter(fl => fl._id === fid)[0]
            if (!filler) return true
            return filler.delete
        }

        const versionedFeatureChanged = () => {
            const formik: any|null = this.state.versionedFeatureFormik
            const target = this.state.versionedFeatureTarget
            const basetype = this.state.versionedFeatureTypeEdit
            const current_version = this.state.versionedFeatureCurrentVersion
            if (basetype===null || target===null || formik===null) return false
            const {current_index, current_version_index} = this.getVersionIndices()
            if (current_index == -1) return true
            return this.state.versionedFeatureValue !== formik.values.feats[basetype][target][current_index].value
        }

        const versionedFeatureModal = (
            <Modal open={versionedFeatureTypeEdit!==null}>
                <ModalHeader>{t('Change versioned feature value')}</ModalHeader>
                <Modal.Content>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={16}>
                            <PInput label={t('New value')} fluid={true} value={this.state.versionedFeatureValue}
                                onChange={(e,d)=>this.setState({versionedFeatureValue: d.value})}/>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={16}>
                            <PInput label={t('Specification')} fluid={true} value={this.state.versionedFeatureSubspec}
                                onChange={(e,d)=>this.setState({versionedFeatureSubspec: d.value||null})}/>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={16}>
                            {this.state.versionedFeatureMessage}
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Content>
                <Modal.Actions>
                    <Button color="red" onClick={()=>this.closeVersionedFeature()}>{t('Cancel')}</Button>
                    <Button color="blue" onClick={()=>this.changeVersionedValue()} disabled={!versionedFeatureChanged()}>{t('Change')}</Button>
                </Modal.Actions>
            </Modal>
        )

        return(
            <Grid>
                {params['features'].map(item => {
                    const fmeta = getmeta(meta, 'feature', item.feature)
                    const basetype = fmeta.type
                    const fgroups = formik.values.feats[basetype] || {}
                    return (
                    <>
                    {versionedFeatureModal}
                    <Grid.Row>
                        <Grid.Column width={16} title={basetype}>
                            <Header as="h3" style={{display: 'inline-block', marginRight: '1em'}}>{getLocalizedLabel(fmeta.label, i18n.language)}</Header>
                            {/* item.slot || item.filler || (item.doc && (typeof fgroups[""] === 'undefined' || fgroups[''].length!=1 || fgroups[''][0].subspec)) ? */
                                item.slot || item.filler ?
                                    <PDropdown options={getRefTargets(meta, formik.values, item, t)}
                                        trigger={(<span><Icon name={item.version ? "edit" : "plus"}/>{item.version ? t('Change for...') : t('Add for...')}</span>)}
                                        scrolling={true} button={true} className="blue mini"
                                        selectOnNavigation={false} selectOnBlur={false}
                                        onClick={(e,d) => {d.value=''}}
                                        onChange={(e,d) => item.version ? this.changeVersionedFeature(formik, d.value, basetype, item.version) : addFeature(formik, meta, d.value, basetype)}/>
                                :
                                    <Button type="button" color="blue" size="mini" icon={item.version ? "edit" : "plus"} title={item.version ? t('Change') : t('Add')}
                                        onClick={(e,d) => item.version ? this.changeVersionedFeature(formik, '', basetype, item.version) : addFeature(formik, meta, '', basetype)}/>
                            /* : null */}
                        </Grid.Column>
                    </Grid.Row>
                    {Object.keys(fgroups).map(group => {
                        const flist = fgroups[group]
                        if (!flist.length) return
                        const myGroupCount = flist.filter(x => x.subspec===null || !x.subspec.split(':').pop().match(/_[^:]+$/)).length
                        const [slot,filler] = group.split('/')
                        const parentDeleted = parentIsDeleted(slot, filler)
                        if ((slot && item.slot && !filler) || (filler && item.filler) || (!slot && !filler && item.doc)) {
                            return (
                                <>
                                {slot ?
                                    filler ?
                                        <Grid.Row className={parentDeleted ? "deletedField" : ''}>
                                            <Grid.Column width={16}><strong>{descFiller(meta, formik.values, slot, filler, t)}</strong></Grid.Column>
                                        </Grid.Row>
                                    :
                                        <Grid.Row className={parentDeleted ? "deletedField" : ''}>
                                            <Grid.Column width={16}><strong>{descSlot(meta, formik.values, slot, t)}</strong></Grid.Column>
                                        </Grid.Row>
                                : 
                                    item.slot || item.filler ? <Grid.Row><Grid.Column width={16}><strong>{t('Unit')}</strong></Grid.Column></Grid.Row> : null
                                }
                                <FieldArray name={"feats["+basetype+"]["+group+"]"}
                                    render={(subformik) => {
                                        const specWidth = 2 + (fmeta.params?.subspecs?.reduce((sum, s) => sum + (s.type === 'enum' ? 3 : 2), 0) || 0)
                                            + (fmeta.params?.aggregate ? 2 : 0)
                                            + (item.version ? 1 : 0)
                                        const valueWidth = 14 - specWidth
                                        return(
                                    <>
                                    {flist.map((f, fi) => {
                                        const finitial = (formik.initialValues.feats[basetype] && formik.initialValues.feats[basetype][group] && formik.initialValues.feats[basetype][group][fi]) ? 
                                            formik.initialValues.feats[basetype][group][fi] : null
                                        const fpath = "feats['"+basetype+"']['"+group+"']."+fi
                                        const fvalue = fpath+".value"
                                        const fspec = fpath+".subspec"
                                        const fdelete = fpath+".delete"
                                        const flastchange = lastChangeLabel(f, userMap, false)
                                        const deleted = f.delete || parentDeleted
                                        const changed = finitial === null || JSON.stringify(finitial.value) !== JSON.stringify(f.value) || finitial.subspec !== f.subspec || deleted
                                        const CustomHelpComponent = fmeta.params && fmeta.params['custom_editor_help_comp'] ? customHelpComponents[fmeta.params['custom_editor_help_comp']] : null

                                        let subspecParts = fmeta.subspec_required ? 
                                            fmeta.params.subspecs?.map((subsp: any) => getLocalizedLabel(subsp.label, i18n.language)) || ['?'] 
                                            : []
                                        if (fmeta.params?.aggregate) {
                                            const label = getLocalizedLabel(fmeta.params.aggregate.label, i18n.language)
                                            subspecParts.push(fmeta.params.aggregate.default_spec ? `(${label})`: label)
                                        }

                                        return (
                                            <>
                                            <Grid.Row className={deleted ? "deletedField condensed" : changed ? "changed condensed" : "condensed"} title={flastchange} verticalAlign="middle">
                                                <InputFeatureType name={fspec} fmeta={fmeta} widthCols={specWidth} inputProps={{disabled: deleted||!!item.version}}
                                                    subSpecOnly={true} defaultNewSubspec={String(fi+1)} requireSubspec={!item.version && myGroupCount>1} current_version={item.version}
                                                    validate={(v) => subspecUnique(v, flist.reduce((acc, x, i) => {
                                                        if (i !== fi && !x.delete) acc.push(x.subspec)
                                                        return acc
                                                    } , []), subspecParts, !!item.version)}/>
                                                <Grid.Column width={valueWidth as SemanticWIDTHS}>
                                                    <InputFeatureValue cunitValues={formik.values} feature={f} fvaluepath={fvalue} fmeta={fmeta} meta={meta} disabled={deleted||!!item.version} validate={valueDefined}
                                                        userMap={userMap} http={http}/>
                                                </Grid.Column>
                                                <Grid.Column width={2} textAlign="right">
                                                    {changed && finitial !== null && !parentDeleted ?
                                                        <Button type="button" color="yellow" icon="undo alternate" size="mini" title={t('undo')}
                                                            onClick={(e,d) => {
                                                                setFieldValue(formik, fvalue, finitial.value, false)
                                                                setFieldValue(formik, fspec, finitial.subspec, false)
                                                                setFieldValue(formik, fdelete, false, false)
                                                            }}/>
                                                    : !parentDeleted /*&& !item.version*/ ?
                                                        <Button type="button" color="red" icon="delete" size="mini" title={t('delete')}
                                                            onClick={(e,d) => {
                                                                if (finitial)
                                                                    setFieldValue(formik, fdelete, true, false)
                                                                else
                                                                    subformik.remove(fi)
                                                            }}/>
                                                    : null }
                                                </Grid.Column>
                                            </Grid.Row>
                                            {fi===flist.length-1 && CustomHelpComponent ? (
                                                <Grid.Row className='condensed'>
                                                    <Grid.Column width={specWidth}></Grid.Column>
                                                    <Grid.Column width={valueWidth as SemanticWIDTHS}><CustomHelpComponent {...this.props} formik={formik} meta={meta}/></Grid.Column>
                                                    <Grid.Column width={2}></Grid.Column>
                                                </Grid.Row>
                                            ) : null}
                                            </>
                                        )
                                    })}
                                    </>)}
                                }/>
                                </>
                            )
                        }
                    })}
                    </>
                    )
                }
                )}
            </Grid>
        )
    }

}

export default withTranslation()(EditFeatureForm)